import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../utils/firebase-config';
import { TextField, Button, Box, Typography, Alert, CircularProgress } from '@mui/material';

const ResetPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    if (!email) {
        setError("Por favor ingresa tu email.");
        setLoading(false);
        return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Se ha enviado un correo para restablecer tu contraseña. Revisa tu bandeja de entrada.");
    } catch (error) {
      console.error(error);
      let msg = "Error al enviar el correo.";
      if (error.code === 'auth/user-not-found') msg = "No existe una cuenta con este correo.";
      if (error.code === 'auth/invalid-email') msg = "Correo inválido.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleResetPassword} sx={{ mt: 1 }}>
      <Typography variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
        Ingresa tu correo electrónico y te enviaremos un enlace para recuperar tu acceso.
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

      <TextField
        margin="normal"
        required
        fullWidth
        id="reset-email"
        label="Dirección de Email"
        name="email"
        autoComplete="email"
        autoFocus
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{ mt: 3, mb: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : "Enviar Correo"}
      </Button>
    </Box>
  );
};

export default ResetPassword;
